import * as React from "react";

export const useDebounceWithCancel = <T>(value: T, delay: number = 500) => {
  const [debouncedValue, setDebouncedValue] = React.useState(value);
  const timerRef = React.useRef<ReturnType<typeof setTimeout>>();

  React.useEffect(() => {
    timerRef.current = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => clearTimeout(timerRef.current);
  }, [value, delay]);

  const cancel = React.useCallback((resetTo: T) => {
    clearTimeout(timerRef.current);
    setDebouncedValue(resetTo);
  }, []);

  return [debouncedValue, cancel] as const;
};

export const useDebounce = <T>(value: T, delay: number = 500) => {
  const [debouncedValue, setDebouncedValue] = React.useState(value);

  React.useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};
